import { Pipe, PipeTransform } from "@angular/core";
import { DataTable, DataTableColumn } from "../data-table.type";

@Pipe({ name: "columnFunction" })
export class ColumnFunctionPipe<T> implements PipeTransform {
  transform(
    _: unknown,
    fn: (row: T, column: DataTableColumn<T>, value: unknown, config: DataTable<T>) => unknown | void,
    row: T,
    column: DataTableColumn<T>,
    value: unknown,
    config: DataTable<T>,
  ): unknown {
    if (fn && typeof fn === "function") {
      return fn(row, column, value, config);
    }

    return null;
  }
}
